import { ValidationCallback } from "validation/validate";

export type MeetingTimeSlotRawFromApi = {
	dateStartsUTC: string;
	dateEndsJustBeforeUTC: string;
};

export const flagValidationErrorsInMeetingTimeSlotRawFromApi: ValidationCallback<
	MeetingTimeSlotRawFromApi
> = (input, { checkField }) => {
	checkField("dateStartsUTC", { type: "string" });
	checkField("dateEndsJustBeforeUTC", { type: "string" });
};
